import React, { memo } from "react";
import { useSelector } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import DoNotTouchOutlinedIcon from "@mui/icons-material/DoNotTouchOutlined";
import { ENTITY_TYPES } from "../../../utils";
import { Grid } from "@mui/material";

const CustomListContainerStyle = {
  marginTop: "0px",
  paddingBottom: "10px",
};

const LegendSx = {
  fontSize: "13px",
  marginRight: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const LegendColorSx = (color) => ({
  display: "inline-block",
  backgroundColor: color,
  width: "12px",
  height: "12px",
  borderRadius: "2px",
  marginRight: "3px",
});

const SelectAllSx = (hide) => ({
  visibility: hide ? "hidden" : "visible",

  "& .MuiTypography-root": {
    fontSize: "13px",
  },
  "& .MuiCheckbox-root": {
    paddingRight: "4px",
  },
});

const HazmatRestrictedLegendSx = {
  fontSize: "18px",
  color: "#ff5722",
  marginRight: "5px",
};

function CustomListContainer({
  children,
  entityType = "",
  handleSelectAll,
  resultLoading = true,
  isResultPresent = false,
  disableSelectAll = false,
  selectAll = false,
  hideSelectAll = false,
  exportButton = <></>,
  stickyHeader = <></>,
  pagination = <></>,
  paginationTotals = <></>,
  resetAction = <></>,
}) {
  const adjQtyError = useSelector((store) => store.global.adjQtyError);
  const isFillInOrder = useSelector(
    (store) => store.global.store.isFillInOrder
  );

  return (
    <div style={CustomListContainerStyle}>
      <div>
        <FormControlLabel
          sx={SelectAllSx(hideSelectAll)}
          control={
            <Checkbox
              size="small"
              disableRipple
              checked={selectAll}
              disabled={disableSelectAll || !isResultPresent || adjQtyError}
              onClick={handleSelectAll}
            />
          }
          label="Select All"
        />
        {isResultPresent && (
          <div
            style={{
              float: "right",
              paddingTop: "5px",
              display: "flex",
            }}
          >
            {entityType === ENTITY_TYPES.planogram && (
              <>
                <div style={LegendSx}>
                  <LocalFireDepartmentOutlinedIcon
                    sx={HazmatRestrictedLegendSx}
                  />{" "}
                  Hazmat
                </div>
                <div style={LegendSx}>
                  <DoNotTouchOutlinedIcon sx={HazmatRestrictedLegendSx} />{" "}
                  Restricted
                </div>
                <div style={LegendSx}>
                  <Checkbox
                    sx={{
                      width: "1rem",
                      height: "1rem",
                      mr: 0.3,
                      cursor: "default",
                    }}
                    size="small"
                    color="success"
                    disableRipple
                    checked={true}
                  />{" "}
                  <span style={{ paddingTop: "2px" }}>Custom Field</span>
                </div>
                <div style={LegendSx}>
                  <span style={LegendColorSx("black")}></span> Duplicate
                </div>
              </>
            )}
            <div style={LegendSx}>
              <span style={LegendColorSx("blue")}></span> Selected
            </div>
            {entityType === ENTITY_TYPES.item && (
              <>
                <div style={LegendSx}>
                  <span style={LegendColorSx("red")}></span> Discontinued
                </div>
                <div style={LegendSx}>
                  <span style={LegendColorSx("orange")}></span> Restricted
                </div>
              </>
            )}
            {entityType !== ENTITY_TYPES.department && (
              <>
                <div style={LegendSx}>
                  <span style={LegendColorSx("green")}></span> Released
                </div>
                <div style={LegendSx}>
                  <span style={LegendColorSx("rgb(156,39,176)")}></span>{" "}
                  Existing
                </div>
                {isFillInOrder && (
                  <div style={LegendSx}>
                    <span style={LegendColorSx("rgb(77,182,172)")}></span> Fill
                    In
                  </div>
                )}
              </>
            )}
            {exportButton}
          </div>
        )}
      </div>
      {!resultLoading && isResultPresent && stickyHeader}
      <div>{children}</div>
      {!resultLoading && isResultPresent && (
        <Grid
          container
          flex
          justifyContent="space-between"
          spacing={1}
          alignItems="center"
          pt={1}
        >
          <Grid item>
            <Grid item>{resetAction}</Grid>
          </Grid>
          <Grid
            item
            sx={{ display: "inline-flex" }}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item sx={{ pr: 1 }}>
              {paginationTotals}
            </Grid>
            <Grid item>{pagination}</Grid>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

export default memo(CustomListContainer);
